import { render, staticRenderFns } from "./KB.vue?vue&type=template&id=f39c16ba&"
import script from "./KB.vue?vue&type=script&lang=js&"
export * from "./KB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports